import {
    Component,
    Input,
    Output,
    EventEmitter,
    OnChanges
} from '@angular/core';
import { SelectItem } from 'primeng-lts/api';

import {
    DeploymentSummaryCompactDescriptor,
    SummaryCompactHeaderSelectorConfig
} from '../types/al-deployment-summary-compact-header.types';

@Component({
    selector: 'al-deployment-summary-compact-header',
    templateUrl: './al-deployment-summary-compact-header.component.html',
    styleUrls: ['./al-deployment-summary-compact-header.component.scss'],
})
export class AlDeploymentSummaryHeaderCompactComponent implements OnChanges {

    @Input() data: DeploymentSummaryCompactDescriptor = new DeploymentSummaryCompactDescriptor();
    @Input() fullScreen: boolean = false;
    @Input() mode: string = 'default-mode';
    @Output() onSelectOption: EventEmitter<SelectItem> = new EventEmitter();

    @Input()
    public set title(text: string) {
        this.setTitle(text);
    }

    multiSelectsConfigs: SummaryCompactHeaderSelectorConfig[] = [];

    options: SelectItem[] = [];

    ngOnChanges(): void {
        this.multiSelectsConfigs = [];
        for (let i = 0; i < this.data.infoBlocks.length; i++) {
            const defaultId: string = this.data.infoBlocks[i].infoBlockOptionDefaultKey;
            const multiSelectConfig: SummaryCompactHeaderSelectorConfig = {
                items: [
                ],
                selectedItem: undefined,
                selectedValue: undefined,
            };
            multiSelectConfig.items = this.data
                .infoBlocks[i]
                .infoBlockOptions
                .map(opt => {
                    opt.icon = opt.data?.icon;
                    return {
                        key: opt.key,
                        data: opt.data,
                        label: opt.name,
                        value: opt.key,
                        icon: opt.icon
                    } as SelectItem;
                });
            multiSelectConfig.selectedItem = multiSelectConfig.items.find(item => item.value === defaultId);
            multiSelectConfig.selectedValue = multiSelectConfig.selectedItem?.value;
            this.multiSelectsConfigs.push(multiSelectConfig);
        }
    }

    shouldDisplayDropDown(infoBlockIdx: number): boolean {
        return this.data.infoBlocks[infoBlockIdx].infoBlockOptions.length > 0;
    }

    setTitle(text: string): void {
        if (this.data?.infoBlocks?.length) {
            if (this.data.infoBlocks[0].infoBlockOptions.length === 0) {
                this.data.infoBlocks[0].infoBlockName = text;
            } else {
                let key = this.data.infoBlocks[0].infoBlockOptionDefaultKey;
                this.data.infoBlocks[0].infoBlockOptions.forEach((option, index) => {
                    if (option.key === key) {
                        this.data.infoBlocks[0].infoBlockOptions[index].name = text;
                    }
                });
            }
        }
    }

    handleSelected(index: number, event:any) {
        const item = this.multiSelectsConfigs[index].items.find(item => item.value === (event.value));
        this.multiSelectsConfigs[index].selectedItem = item;
        this.onSelectOption.emit(item);
    }
}


